import { getPCA } from "../../app/pca"

const pca = getPCA()

export default function useGetPcaUserName() {
	if (pca) {
        const account = pca.getActiveAccount() ?? pca.getAllAccounts()[0]
        return account?.username ?? null
    }
    return null
}